
import { computed, defineComponent, PropType } from "vue";
import {
  resolveUnitHeaderLines,
  type PdfUnitHeaderVariant,
} from "@/components/shared/pdf-viewer/pdf-document-header";

export default defineComponent({
  name: "PdfDocumentHeader",

  props: {
    tenDonVi: {
      type: String,
      default: "",
    },
    tenDonViCha: {
      type: String,
      default: "",
    },
    capDonVi: {
      type: Number,
      default: null,
    },
    variant: {
      type: String as PropType<PdfUnitHeaderVariant>,
      default: "document",
    },
    showNationalMotto: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const unitLines = computed(() =>
      resolveUnitHeaderLines({
        tenDonVi: props.tenDonVi,
        tenDonViCha: props.tenDonViCha,
        capDonVi: props.capDonVi,
        variant: props.variant,
      })
    );

    return {
      unitLines,
    };
  },
});
